import React from 'react'
import PropTypes from 'prop-types'
import { MaskedInputField } from '@adc/ui-core'
import { CREDIT_CARDS } from '../utils'
const cvvMask = Array(4).fill(/\d/)
const amexTooltip =
  'Your security code is a 4-digit number on the front of your credit card.'
const othersTooltip =
  'Your security code is a 3-digit number on the back of your credit card.'

const CVV = props => {
  const tooltip = props.type === CREDIT_CARDS.AMEX ? amexTooltip : othersTooltip
  return (
    <MaskedInputField
      autoComplete='cc-csc'
      guide={false}
      helpContent={tooltip}
      label='CVV'
      mask={cvvMask}
      {...props}
      type='text'
    />
  )
}

CVV.propTypes = {
  type: PropTypes.object.isRequired,
}

export default CVV
